(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/store/swish-slice.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/store/swish-slice.js');
"use strict";


const {
  data
} = svs.accountservicesReact.deposit;

const getInitialState = () => ({
  amount: '',
  buttonText: 'Sätt in pengar',
  accountBalance: data.accountBalance || '',
  cellPhone: data.cellPhone || null,
  newCellPhone: data.cellPhone || null,
  returnUrl: data.returnUrl || '',
  isChangePhoneExpanded: false
});
const swishSlice = RTK.createSlice({
  name: 'swish',
  initialState: getInitialState(),
  reducers: {
    cellphoneChangeAction: (state, action) => {
      if (!isNaN(action.payload)) {
        state.cellPhone = action.payload;
        state.newCellPhone = action.payload;
      }
    },
    newCellphoneChangeAction: (state, action) => {
      if (!isNaN(action.payload)) {
        state.newCellPhone = action.payload;
      }
    },
    changeCellPhoneAccordionAction: (state, action) => {
      state.isChangePhoneExpanded = action.payload;
    }
  }
});
svs.accountservicesReact.deposit.store.swish = svs.accountservicesReact.deposit.store.swish || {};
svs.accountservicesReact.deposit.store.swish.actions = swishSlice.actions;
svs.accountservicesReact.deposit.store.swish.reducer = swishSlice.reducer;
svs.accountservicesReact.deposit.store.swish.initialState = getInitialState();

 })(window);